import 'react-native-url-polyfill/auto';
import { createLogger } from '@/lib/logger';
import { createClient } from '@supabase/supabase-js';
import AsyncStorage from '@react-native-async-storage/async-storage';

const log = createLogger('SUPABASE');

const DEFAULT_SUPABASE_URL = 'https://bjxwumvqdjzvjqxqndah.supabase.co';

const resolveSupabaseUrl = () => {
  const envUrl = process.env.EXPO_PUBLIC_SUPABASE_URL;
  if (envUrl && typeof envUrl === 'string') {
    try {
      const parsed = new URL(envUrl);
      if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
        if (parsed.hostname) {
          return { url: parsed.toString(), host: parsed.hostname, source: 'env' as const };
        }
      }
    } catch {
      // fall through to default
    }
  }
  const fallback = new URL(DEFAULT_SUPABASE_URL);
  return { url: fallback.toString(), host: fallback.hostname, source: 'default' as const };
};

const { url: supabaseUrl, host: supabaseHost, source: supabaseSource } = resolveSupabaseUrl();
const supabaseAnonKey = process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY;
if (!supabaseAnonKey) {
  throw new Error('Missing EXPO_PUBLIC_SUPABASE_ANON_KEY');
}

if (__DEV__) {
  log.info('[SUPABASE] Initialization');
  log.info('  URL:', supabaseUrl);
  log.info('  URL Host:', supabaseHost);
  log.info('  Source:', supabaseSource);
  log.info('  Anon Key (last 6):', supabaseAnonKey.slice(-6));
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: AsyncStorage,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false,
  },
});

export const getSupabaseConfig = () => ({
  url: supabaseUrl,
  urlHost: supabaseHost,
  anonKey: supabaseAnonKey,
  anonKeyLast6: supabaseAnonKey.slice(-6),
});
